import React from 'react';
import { HardDrive, Infinity as InfinityIcon } from 'lucide-react';

// Compact horizontal storage usage meter
export default function StorageMeter({ data, compact = false }) {
  if (!data) return null;
  if (data.unlimited) {
    return (
      <div className="card-shell p-4 flex items-center gap-3" data-testid="storage-meter">
        <div className="w-10 h-10 rounded-lg grid place-items-center" style={{ background: 'rgba(167,139,250,0.15)', border: '1px solid rgba(167,139,250,0.4)' }}>
          <InfinityIcon className="w-5 h-5 text-[#a78bfa]" />
        </div>
        <div>
          <div className="text-[12px] uppercase tracking-wider text-white/45">Storage</div>
          <div className="font-display text-[18px] leading-none mt-1">Unlimited</div>
        </div>
      </div>
    );
  }
  const usedGb = (data.used_mb / 1024).toFixed(2);
  const quotaGb = (data.quota_mb / 1024).toFixed(1);
  const pct = Math.max(0, Math.min(100, data.percent || 0));
  const danger = pct >= 90;
  const warn = pct >= 70 && pct < 90;
  const color = danger ? '#ff6b8a' : warn ? '#ffcf52' : '#22d3ee';

  return (
    <div className="card-shell p-4" data-testid="storage-meter">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <HardDrive className="w-4 h-4" style={{ color }} />
          <span className="text-[12px] uppercase tracking-wider text-white/45">Storage</span>
        </div>
        <div className="text-[13.5px] font-semibold" style={{ color }}>{pct}%</div>
      </div>
      <div className="mt-2 h-2 rounded-full bg-white/10 overflow-hidden">
        <div className="h-full transition-all" style={{ width: `${pct}%`, background: color }} />
      </div>
      <div className="mt-2 flex items-center justify-between text-[12px] text-white/55">
        <span><span className="text-white/90 font-semibold">{usedGb} GB</span> of {quotaGb} GB used</span>
        {!compact && <span className="capitalize text-white/45">Plan: {data.plan}</span>}
      </div>
    </div>
  );
}
